import React from "react";

import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import OrderHistory from "../components/orderHistory/OrderHistory";

export default function OrderHistoryView() {
  return (
    <div className="pageWrapper">
      <Header title="Bestelgeschiedenis" needsLocation="Yes" />
      <div className="contentWrapper fadeInDelayed">
        <OrderHistory />
      </div>
      <BottomNavBar />
    </div>
  );
}
